$.fn.TextBgColor = function(options) {

  let self = this
  var words = self.text().split(" ");
  self.empty();
  $.each(words, function(i, word) {
    self.append($("<span>").text(word));
  });
  self.addClass('text-bg--breakable');

  if(self.hasClass('text-bg-animated')) {
    self.find('> span').each(function() {
      var width = $(this).outerWidth();
      $(this).clone().css('--width', width + 'px').appendTo($(this));
    });
  }

  function animateBackground() {
    if(self.hasClass('text-bg-animated') && !self.hasClass('animate')) {
      if (self.isInViewport()) {
        self.addClass('animate');
      }
    }
  }

  $(window).on('resize scroll', function() {
    animateBackground()
    if(self.hasClass('text-bg-animated')) {
      self.find('> span').each(function() {
        var width = $(this).outerWidth();
        $(this).find('span').css('--width', width + 'px');
      });
    }
  });

  setTimeout(function() {
    animateBackground();
  }, 1000);

  return function() {
    return self
  }()
}

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
